import { render } from "./favorite-page.vue?vue&type=template&id=d2aa6bf8"
import script from "./favorite-page.vue?vue&type=script&lang=js"
export * from "./favorite-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__